import { render, staticRenderFns } from "./rewardBuildDiscountEdit.vue?vue&type=template&id=2ba0980e&scoped=true&"
import script from "./rewardBuildDiscountEdit.vue?vue&type=script&lang=js&"
export * from "./rewardBuildDiscountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0980e",
  null
  
)

export default component.exports